// extracted by mini-css-extract-plugin
module.exports = {"popup-lang":"langPopup_popup-lang__28EQG","item":"langPopup_item__6_twc","active":"langPopup_active__eJziu"};